// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1wzbn","buttons":"RemoveExpirationActionButtons_buttons__1FvCb"};